import React, { Component } from "react";
import _ from "lodash";
import InputField from "components/InputField/InputField";
import inputFormatter from "services/userInputFormatter";
import FileField from "components/InputField/FileField";

class CourseMaterialModal extends Component {
  constructor(props) {
    super(props);

    const { material } = props;

    this.state = {
      courseMaterial: {
        title: material.id ? material.title : "",
        file: "",
      },
      errors: {},
    };
  }

  onFieldChange = (event) => {
    const { courseMaterial } = this.state;
    const input = inputFormatter.formatField(
      event.target.name,
      event.target.value
    );
    const courseMaterialData = {
      ...courseMaterial,
      [event.target.name]: input,
    };

    this.setState({ courseMaterial: courseMaterialData, errors: {} });
  };

  onSubmit = () => {
    const { material, createCourseMaterial, updateCourseMaterial } = this.props;
    const { courseMaterial } = this.state;
    let errors = {};

    if (!courseMaterial.title) {
      errors = { title: ["Can't be blank"] };
    }
    if (!material.id && !courseMaterial.file) {
      errors = { ...errors, file: ["Can't be blank"] };
    }

    if (_.isEmpty(errors)) {
      if (material.id) {
        updateCourseMaterial({
          ...material,
          ...courseMaterial,
        });
      } else {
        createCourseMaterial({
          ...material,
          ...courseMaterial,
        });
      }
    } else {
      this.setState({ errors });
    }
  };

  render() {
    const { material } = this.props;
    const { courseMaterial, errors } = this.state;
    const isNew = !material.id;

    return (
      <div className="course-material-modal row">
        <h3>{isNew ? "Add Course Material" : "Edit Course Material"}</h3>
        <form className="col s12">
          <InputField
            className="col s12"
            label="Title of course material"
            field_name="title"
            onChange={this.onFieldChange}
            errors={errors.title}
            value={courseMaterial.title}
          />
          <FileField
            className="col s12"
            field_name="file"
            onChange={this.onFieldChange}
            label="Add file to your publication"
            errors={errors.file}
          />
          {material.file_url && (
            <div className="col s12">
              <a
                className="button_classic material-form-file"
                type="button"
                href={material.file_url}
                target="_blank"
              >
                View File
              </a>
            </div>
          )}
          <button
            onClick={this.onSubmit}
            className="button_classic"
            type="button"
            name="button"
          >
            Save
          </button>
        </form>
      </div>
    );
  }
}

export default CourseMaterialModal;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/CourseMaterials/CourseMaterialModal.jsx